module.exports = __webpack_public_path__ + "static/media/img4.af1ecefa.jpg";